const plug = new Object();
import store from './../store'

plug.install = (Vue, options) => {
    Vue.mixin({
        components: {
            LayFooterZH: re => require(['@/components/ZH/LayFooter.vue'], re), // 汉语端--底部
            LayHeaderZH: re => require(['@/components/ZH/LayHeader.vue'], re), // 汉语端--头部
            Nodata: re => require(['@/components/ZH/Nodata.vue'], re), // 汉语端--暂无数据
            ZhSearchClass:re => require(['@/components/ZH/ZhSearchClass'], re),

            file_preview:re => require(['@/components/file_preview.vue'], re),//pdf预览
            gobackZh: re => require(['@/components/ZH/gobackZh'], re),//返回键
            ZhDetailaLeft: re => require(['@/components/ZH/ZhDetailaLeft'], re),//详情页的左侧边

            //书籍列表
            zhLayListBooks: re => require(['@/components/ZH/zhLayListBooks'], re),
            //目录数据库列表
            zhLayCatalogDatabase: re => require(['@/components/ZH/zhLayCatalogDatabase'], re),
            //期刊列表
            zhLayListJournal: re => require(['@/components/ZH/zhLayListJournal'], re),
            //论文列表
            zhLayPaperList: re => require(['@/components/ZH/zhLayPaperList'], re),

        },
        computed: {},
        mounted() {
        }

    })

}
export default plug
